//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wxlogin from 'vue-wxlogin'
import env from '../../plugins/environment'
export default {
  components: { wxlogin },

  data() {
    return {
      wx: {
        appid: 'wx28e708201e3983b8',
        scope: 'snsapi_login',
        redirect_uri: encodeURIComponent('https://www.chongya.fun/redirect'),
        state: '1',
        theme: 'white',
        href:window.parent.location.origin + '/wechatCodeStyle.css',
      },
      activeDate: 1,
      shouldFakeButtonShow: !env.isProd(),
    }
  },

  mounted: function () {
    if (!env.isProd()) {
      this.wx.redirect_uri = encodeURIComponent('https://www.chongya.fun/beta/redirect')
      console.warn(`当前为 beta 环境，微信二维码的重定向地址变为：${decodeURIComponent(this.wx.redirect_uri)}`)
    }
  },

  methods: {
    refresh: function () {
      this.activeDate = new Date().getTime()
    },

    fakeLoginSuccess: function () {
      this.$q.notify('提示：假装登录成功可能导致某些账户功能不好使，如绑定微信、修改昵称等。')
      this.$router.replace({ path: '/redirect', query: { code: 'fakecode' } })
    },
  },
}
